/* ImportScreenComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");

const Renderer = require("./ImportScreenRenderer");

class ImportScreenComponent extends EventEmitter {
    constructor(logger, userSession, io) {
        super();
        this._logger = logger;
        this._userSession = userSession;
        this._io = io;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    get logger() {
        return this._logger;
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._io = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ImportScreenComponent.shutdown() error.");
            }
        );
    }
    sendImportData(data) {
        this._context.resolve({
            import: data[0],
        });
    }
    sendImportError(err) {
        this._context.reject(err);
    }
    parseData(file, type) {
        new Promise((resolve, reject) => {
            const onloadHandler = (type) => (e) => {
                const data = e.target.result;
                if (type === "json") {
                    this._parseJson(data).then(resolve, reject);
                }
            };
            const onErrorHandler = (error) => {
                reject({
                    errorCode: "FileReadError",
                    errorMsg: "File reading error",
                    errorStack: error,
                });
            };
            if (type === "json") {
                let fileReader = new FileReader();

                fileReader.onload = onloadHandler(type);
                fileReader.onerror = onErrorHandler;
                fileReader.readAsText(file);
            } else {
                reject({
                    errorCode: "UnknownImportFileType",
                    errorMsg: `Unknown file type used for import: ${type}`,
                });
            }
        })
            .then((data) => this.sendImportData(data))
            .catch((error) => {
                this._logger.warn({error}, "ImportScreenComponent data parse error.");
                this.sendImportError(error);
            });
    }

    cancelAction(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _parseJson(data) {
        return new Promise((resolve, reject) => {
            try {
                let parsedJson = JSON.parse(data);
                resolve(_.isArray(parsedJson) ? parsedJson : [parsedJson]);
            } catch (err) {
                if (err.name && err.name === "SyntaxError") {
                    reject({
                        errorCode: "SyntaxError",
                        errorMsg: "Unable to parse JSON file.",
                    });
                } else {
                    reject(err);
                }
            }
        });
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ImportScreenComponent;
